import React, {memo} from 'react'
import {withErrorHandling, withHelmet, withPropsPresent, withServiceData, withVersionData} from '../../hoc'
import {OASUI, RedocUI} from './versions'

const _DirectorySelection = (
  {
    display = 'OAS (swagger)',
    version,
  }
) => {
  const {contract} = version
  return (
    <>
      {
        display === 'api' && (<RedocUI contract={contract}/>)
      }
      {
        display === 'oas' && (<OASUI contract={contract}/>)
      }
    </>
  )
}

let DirectorySelection = (props) => {
  return (<_DirectorySelection {...props}/>)
}

DirectorySelection = withPropsPresent(DirectorySelection, ['version'])
DirectorySelection = withHelmet(DirectorySelection, (props) => {
  const {service} = props
  if (service) {
    return `Directory - ${service.name}`
  }
  return 'Directory'
})
DirectorySelection = withVersionData(DirectorySelection, 'Loading version...')
DirectorySelection = withServiceData(DirectorySelection, 'Loading service...')
DirectorySelection = withErrorHandling(DirectorySelection)
DirectorySelection = memo(DirectorySelection)

export {_DirectorySelection, DirectorySelection}

export default DirectorySelection